transaction id soit generer automatiquement dans ce code : <template>
  <div>
    <!-- Toolbar -->
    <v-toolbar dense tabs color="primary darken-2" dark>
      <v-toolbar-title class="pl-2">Create Business Account</v-toolbar-title>
    </v-toolbar>

    <!-- Main Container -->
    <v-container>
      <v-layout row>
        <v-flex xs12 md8 lg6 offset-md2 offset-lg3>
          <v-slide-y-transition mode="out-in">
            <div>
              <!-- Form Title -->
              <h2 class="blue white--text font-weight-bold subheading pa-2 text-xs-left">
                Create Your Business Account
              </h2>
              <v-divider></v-divider>

              <!-- Business Account Form -->
              <v-card color="white pa-3 pt-1">
                <v-layout row>
                  <v-flex xs12 md10 offset-md1>
                    <!-- Name Field -->
                    <v-layout row>
                      <v-flex xs2 sm1>
                        <i class="teal--text fas fa-user fa-2x mt-2"></i>
                      </v-flex>
                      <v-flex xs10 sm10>
                        <v-text-field
                          v-model="form.name"
                          label="Account Name"
                          outlined
                          clearable
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <!-- Username Field (Required) -->
                    <v-layout row>
                      <v-flex xs2 sm1>
                        <i class="teal--text fas fa-user-circle fa-2x mt-2"></i>
                      </v-flex>
                      <v-flex xs10 sm10>
                        <v-text-field
                          v-model="form.username"
                          label="Username"
                          :rules="[v => !!v || 'Username is required']"
                          outlined
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <!-- Telephone Field (Required) -->
                    <v-layout row>
                      <v-flex xs2 sm1>
                        <i class="teal--text fas fa-phone fa-2x mt-2"></i>
                      </v-flex>
                      <v-flex xs10 sm10>
                        <v-text-field
                          v-model="form.telephone"
                          label="Phone Number"
                          :rules="phoneRules"
                          outlined
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <!-- Email Field -->
                    <v-layout row>
                      <v-flex xs2 sm1>
                        <i class="teal--text fas fa-envelope fa-2x mt-2"></i>
                      </v-flex>
                      <v-flex xs10 sm10>
                        <v-text-field
                          v-model="form.email"
                          label="Email Address"
                          :rules="emailRules"
                          outlined
                          clearable
                        ></v-text-field>
                      </v-flex>
                    </v-layout>

                    <!-- Affiliate Referral Field (Required) -->
                    <v-layout row>
                      <v-flex xs2 sm1>
                        <i class="teal--text fas fa-code fa-2x mt-2"></i>
                      </v-flex>
                      <v-flex xs10 sm10>
                        <v-text-field
                          v-model="form.affiliate_referral"
                          label="Affiliate Referral Code"
                          :rules="referralRules"
                          :disabled="!!$route.query.referral"

                          outlined
                          required
                        ></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-flex>
                </v-layout>

                <!-- Submit Button -->
                <div class="text-xs-right">
                  <v-btn
                    color="teal darken-2"
                    class="white--text"
                    @click="submitForm"
                    small
                    round
                  >
                    Next
                  </v-btn>
                </div>
              </v-card>
            </div>
          </v-slide-y-transition>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Payment Dialog -->
    <v-dialog v-model="showPayment" width="500px">
      <v-card>
        <v-card-title class="headline primary darken-2 white--text">
          Confirm Payment
        </v-card-title>
        <v-card-text class="pa-4">
          <p class="mb-0">
            You are about to pay <b>10500 FCFA</b> to create your business account.
          </p>
          <p class="mb-0">
            Please select your payment method and follow the instructions below.
          </p>

          <!-- Sélection de la méthode de paiement -->
          <v-radio-group v-model="paymentMethod" class="mt-4">
            <v-radio label="MTN Mobile Money" value="MTN"></v-radio>
            <v-radio label="Orange Money" value="OM"></v-radio>
          </v-radio-group>

          <!-- Code USSD Généré -->
          <div v-if="ussdCode" class="ussd-code pa-3 mt-4">
            <code>{{ ussdCode }}</code>
            <v-btn 
              icon 
              @click="copyUSSD"
              class="ml-2"
              title="Copy USSD code"
            >
              <v-icon>mdi-content-copy</v-icon>
            </v-btn>
            <v-btn 
              color="primary" 
              small
              :href="dialLink"
              target="_blank"
              id="dial_transaction"
            >
              <v-icon left>mdi-phone</v-icon>
              Dial Now
            </v-btn>
          </div>

          <!-- Champ pour l'ID de transaction -->
          <v-text-field
            v-model="transactionId"
            label="Transaction ID"
            :rules="[v => !!v || 'Transaction ID is required']"
            outlined
            required
            class="mt-4"
          ></v-text-field>
        </v-card-text>

        <v-card-actions class="px-3">
          <v-btn color="teal" flat @click="showPayment = false">Cancel</v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            color="teal darken-2" 
            class="white--text" 
            @click="confirmPayment"
            :loading="processingPayment"
          >
            Confirm
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      form: {
        name: '',
        username: '',
        telephone: '',
        email: '',
        affiliate_referral: '',
      },
      showPayment: false,
      paymentMethod: '',
      transactionId: '',
      ussdCode: '',
      dialLink: '',
      processingPayment: false,
      phoneRules: [
        v => !!v || 'Phone number is required',
        v => /^[0-9]{9}$/.test(v) || 'Phone number must be 9 digits',
      ],
      emailRules: [
        v => !v || /.+@.+\..+/.test(v) || 'Email must be valid',
      ],
      referralRules: [
        v => !!v || 'Referral code is required',
        v => /^[A-Z0-9]{6}$/.test(v) || 'Referral code must be 6 alphanumeric characters',
      ],
    };
  },
  methods: {
    async submitForm() {
      if (
        !this.form.username ||
        !this.form.telephone ||
        !this.form.affiliate_referral
      ) {
        this.showSnackbar('Please fill in all required fields.', 'error');
        return;
      }

      this.showPayment = true;
      this.generateUSSD();
    },

    generateUSSD() {
      const amount = 10500;
      const merchantCode = this.paymentMethod === 'MTN' 
        ? this.$store.state.MerchantCodeMTN 
        : this.$store.state.MerchantCodeOrange;

      if (this.paymentMethod === 'MTN') {
        this.ussdCode = `*126*4*${merchantCode}*${amount}#`;
        this.dialLink = `tel:${encodeURIComponent(this.ussdCode)}`;
      } else if (this.paymentMethod === 'OM') {
        this.ussdCode = `#150*47*${merchantCode}*${amount}#`;
        this.dialLink = `tel:${encodeURIComponent(this.ussdCode)}`;
      }
    },

    async confirmPayment() {
      if (!this.transactionId) {
        this.showSnackbar('Please enter the transaction ID.', 'error');
        return;
      }

      this.processingPayment = true;

      try {
        // Vérification du statut de la transaction via l'API de paiement
        const paymentStatus = await this.verifyPayment(this.transactionId);

        if (paymentStatus.success) {
          const response = await axios.post('/api/v1/savingsbusiness-account/', {
            ...this.form,
            payment_method: this.paymentMethod,
            transaction_id: this.transactionId,
          });

          if (response.data.success) {
            this.showSnackbar('Business account created successfully!', 'success');
            this.resetForm();
            this.showPayment = false;
          } else {
            this.showSnackbar('Failed to create business account. Please try again.', 'error');
          }
        } else {
          this.showSnackbar('Payment verification failed. Please check the transaction ID.', 'error');
        }
      } catch (error) {
        this.showSnackbar('An error occurred. Please try again.', 'error');
        console.error('Error:', error);
      } finally {
        this.processingPayment = false;
      }
    },

    async verifyPayment(transactionId) {
      // Intégration avec l'API de paiement
      try {
        const response = await axios.post('/api/v1/savings/payment/verify/', {
          transaction_id: transactionId,
          payment_method: this.paymentMethod,
        });
        return response.data;
      } catch (error) {
        console.error('Payment verification error:', error);
        return { success: false };
      }
    },

    copyUSSD() {
      navigator.clipboard.writeText(this.ussdCode);
      this.showSnackbar('USSD code copied!', 'success');
    },

    resetForm() {
      this.form = {
        name: '',
        username: '',
        telephone: '',
        email: '',
        affiliate_referral: '',
      };
      this.paymentMethod = '';
      this.transactionId = '';
      this.ussdCode = '';
      this.dialLink = '';
    },

    showSnackbar(message, type) {
      this.$store.commit('setSnackBarMessage', message);
      this.$store.commit('setSnackBarColor', type === 'success' ? 'teal darken-2' : 'red darken-4');
      this.$store.commit('activateSnackBar', true);
    },
  },
};
</script>

<style scoped>
.ussd-code {
  background: #f5f5f5;
  border-radius: 4px;
  font-size: 1.2em;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.v-dialog {
  border-radius: 8px;
}

.v-card__title {
  background-color: #1976d2;
  color: white;
}

.v-card__text {
  font-size: 16px;
}

.v-radio-group {
  margin-top: 16px;
}

.v-radio {
  margin-bottom: 8px;
}
</style>